/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Fit_Files_UploadInputs */

const en_ui_fit_files_upload = /** @type {(inputs: Ui_Fit_Files_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload FIT files`)
};

const de_ui_fit_files_upload = /** @type {(inputs: Ui_Fit_Files_UploadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`FIT-Dateien hochladen`)
};

/**
* | output |
* | --- |
* | "Upload FIT files" |
*
* @param {Ui_Fit_Files_UploadInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_fit_files_upload = /** @type {((inputs?: Ui_Fit_Files_UploadInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Fit_Files_UploadInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_fit_files_upload(inputs)
	return de_ui_fit_files_upload(inputs)
});